var showTagList = function(ul, start, end, cl)
{
    if (ul != null && ul.children.length > 3) 
	{
        for (var x = start; x < ul.children.length - end; x++)
            ul.children[x].style.display = 'none';

        var newItem = document.createElement("LI");
        var newAnchor = document.createElement("a");// Create a <li> node
        newAnchor.href = "javascript:void(0)";
        var textnode = document.createTextNode("...");  // Create a text node
        newAnchor.appendChild(textnode);

		if(cl)
			newAnchor.classList.add(cl);
		
        newAnchor.addEventListener("click", function () 
		{
            for (var x = start; x < ul.children.length - end; x++)
                ul.children[x].style.display = 'inline-block';

            this.parentElement.style.display = 'none';
        });

        newItem.appendChild(newAnchor);

        // Add ellipsis node before last hidden element
        ul.insertBefore(newItem, ul.children[start]);
    }
}

module.exports = showTagList;



// WEBPACK FOOTER //
// ./lib/showTagList.js